const removeProperties = (object, ...keys): Record<string, unknown> =>
  Object.entries(object).reduce(
    (prev, [key, value]) => ({
      ...prev,
      ...(!keys.includes(key) && { [key]: value }),
    }),
    {},
  );

export default removeProperties;
